import rusdIcon from "../../../media/icons/rusd.webp";

export function RUSDIcon() {
    return (
        <img src={rusdIcon} width={38} height={38} alt='rUSD'/>
    )
}
